import { Button, Spinner } from "@aircall/ds";
import { useTranslation } from "react-i18next";

import { SubmitButtonProps } from "./SubmitButton.decl";

export function SubmitButton({
  loading = false,
  children,
  loadingLabel,
  ...props
}: SubmitButtonProps) {
  const { t } = useTranslation();
  const content = children ?? t("submit");
  return (
    <Button
      variant="secondary"
      size="lg"
      data-test="submit-button"
      type="submit"
      {...props}
    >
      {loading ? (
        <>
          <Spinner data-test="loader" />
          {loadingLabel ?? t("submitting")}
        </>
      ) : (
        content
      )}
    </Button>
  );
}
